import { render, staticRenderFns } from "./FilterSEARCH.vue?vue&type=template&id=5348c8b8&scoped=true&"
import script from "./FilterSEARCH.vue?vue&type=script&lang=js&"
export * from "./FilterSEARCH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348c8b8",
  null
  
)

export default component.exports